import { css } from '@emotion/react';

export const PaddingStyle = ({
	p,
	t,
	l,
	b,
	r,

	h,
	v,

	np,
}: {
	p?: number;
	t?: number;
	l?: number;
	b?: number;
	r?: number;

	h?: number;
	v?: number;

	np?: boolean;
}) => css`
	${!!np &&
	css`
		padding: 0;
	`};

	${!!p &&
	css`
		padding: ${p}px;
	`};

	${!!t &&
	css`
		padding-top: ${t}px;
	`};

	${!!b &&
	css`
		padding-bottom: ${b}px;
	`};

	${!!l &&
	css`
		padding-left: ${l}px;
	`};

	${!!r &&
	css`
		padding-right: ${r}px;
	`};

	${!!h &&
	css`
		padding-left: ${h}px;
		padding-right: ${h}px;
	`};

	${!!v &&
	css`
		padding-top: ${v}px;
		padding-bottom: ${v}px;
	`};
`;
